module.exports = __webpack_public_path__ + "static/media/logo.bd3ad65e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/logo.svg
// module id = 327
// module chunks = 0